var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFridge = function SvgFridge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.291,
    height: 29.327
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2a4d4f"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3990",
    d: "M14.787 0H2.444A2.451 2.451 0 0 0 0 2.444v21.873a2.4 2.4 0 0 0 1.527 2.26l.367 1.466a1.7 1.7 0 0 0 3.3 0L5.5 26.76h6.293l.306 1.283a1.7 1.7 0 0 0 3.3 0l.367-1.466a2.4 2.4 0 0 0 1.527-2.26V2.444A2.545 2.545 0 0 0 14.787 0ZM2.444 1.222h12.342a1.226 1.226 0 0 1 1.222 1.222V8.8H1.222V2.444a1.225 1.225 0 0 1 1.221-1.221Zm1.531 26.517a.465.465 0 0 1-.489.367.4.4 0 0 1-.427-.367L2.811 26.7h1.344Zm10.2 0a.432.432 0 0 1-.855 0l-.245-1.039h1.344Zm.612-2.2H2.444a1.226 1.226 0 0 1-1.222-1.222v-14.3h14.787v14.3a1.227 1.227 0 0 1-1.222 1.221Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3991",
    d: "M3.117 7.516a.577.577 0 0 0 .611-.611V3.544a.611.611 0 1 0-1.221 0v3.3a.669.669 0 0 0 .611.672Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3992",
    d: "M3.117 11.792a.577.577 0 0 0-.611.611v5.56a.611.611 0 1 0 1.221 0v-5.56a.612.612 0 0 0-.61-.611Z"
  }))));
};
export default SvgFridge;